import React from "react";
import GenderCard from "./GenderCard";
import { Gender, gendersList } from "constants/genders";
import { useAppDispatch, useAppSelector } from "store";
import { setGenderType } from "store/slices/registration";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel";
import Logo from "../../../../assets/svg/logoIcon.svg";

const GenderSelect = () => {
  const dispatch = useAppDispatch();
  const userGender = useAppSelector((state) => state.registration.gender);

  const onSetGenderType = (type: string) => {
    ReactGA.event("genderTypeSelected");
    ReactPixel.trackCustom("genderTypeSelected");
    dispatch(setGenderType(type));
  };

  return (
    <main>
      <div>
        <img src={Logo} alt="" />
      </div>
      <div className="titleContainer" style={{ marginTop: 40 }}>
        <h2 className="title">
          Custom
          <span className="gradient-pink-text"> Astrology Forecast</span> with
          Detailed Predictions
        </h2>
      </div>
      <p className=" font-s14 brownish-gray-text font-w400" style={{ marginTop: 12, fontFamily: 'Golos' }}>
        Fill out a brief, 1-minute questionnaire for <br /> personalized astrological
        insights. Predictions may <br /> vary and are not guaranteed for every
        individual.
      </p>
      <div className="mt40">
        <p className="text-uppercase font-w700 fMontserrat font-s10 brownish-gray-text">
          Select your gender to start
        </p>
        <div className="flex i-align-s gap12 mt16">
          {gendersList.map((gender: Gender) => (
            <GenderCard
              setGenderType={onSetGenderType}
              type={gender.type}
              icon={gender.icon}
              isSelected={userGender === gender.type}
              key={gender.id}
            />
          ))}
        </div>
      </div>
    </main>
  );
};

export default GenderSelect;